import { useEffect } from 'react';
import { GridColumn } from '@cbhq/cds-common';
import { Divider, Grid, VStack } from '@cbhq/cds-web/layout';
import { TextLabel1 } from '@cbhq/cds-web/typography';
import { Fingerprint, getSealedFingerprintPro } from '@cbhq/identity-fingerprint';
import { createWrappedPromise } from '@cbhq/identity-shared/utils';

import { useMappedApplications } from '../hooks/useMappedApplications';
import { useClientProps } from '../providers/ClientPropsProvider';

import { ApplicationButton } from './ApplicationButton';

type AppsListProps = {
  itensPerRow?: GridColumn;
};

export function AppsList({ itensPerRow = 3 }: AppsListProps) {
  const { target } = useClientProps();
  const mappedApplications = useMappedApplications();
  const fingerprint = createWrappedPromise<Fingerprint | undefined>();

  useEffect(() => {
    getSealedFingerprintPro({ target })
      .then(fingerprint.resolve)
      .catch(() =>
        fingerprint.resolve({
          requestId: '',
          sealedResult: '',
        }),
      );
  }, [fingerprint, target]);

  return (
    <VStack testID="AppsList">
      {mappedApplications.map(({ category, applications }, index) => {
        const showDivider = !(mappedApplications.length - 1 === index);
        return (
          <VStack testID={`group-${category.identifier}`} key={category.identifier}>
            <VStack paddingY={1} paddingX={2}>
              <TextLabel1 as="p" color="fgMuted" display="block">
                {category.label}
              </TextLabel1>

              <Grid
                columns={itensPerRow}
                paddingTop={1}
                gap={1}
                alignItems="center"
                justifyContent="center"
              >
                {applications.map((application) => {
                  return (
                    <ApplicationButton
                      key={application.applicationId}
                      application={application}
                      fingerprint={fingerprint}
                    />
                  );
                })}
              </Grid>
            </VStack>
            {showDivider && <Divider />}
          </VStack>
        );
      })}
    </VStack>
  );
}
